'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'support', '$security', 'OperatorService', 'types', 'okveds', 'areases', 'operators', 'industries', 'operations',
    function ($scope, $modalInstance, support, $security, OperatorService, types, okveds, areases, operators, industries, operations) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.isSelect = isSelect;
        $scope.isShowEdit = isShowEdit;
        $scope.allowEdit = allowEdit;
        $scope.cancelEdit = cancelEdit;
        $scope.uploadFile = uploadFile;
        $scope.downloadFile = downloadFile;
        $scope.parseArrayNames = parseArrayNames;
        $scope.parseArrayCodes = parseArrayCodes;
        $scope.parseFieldWithOperator = parseFieldWithOperator;
        $scope.getOperatorDisplayName = OperatorService.getDisplayName;
        $scope.isBetween = OperatorService.isBetween;
        $scope.formState = {
            isValid: false
        }

        $scope.types = types;
        $scope.areases = areases;
        $scope.okveds = okveds;
        $scope.operators = operators;
        $scope.industries = industries;
        $scope.operations = operations;

        $scope.tinymceOptions = {
            plugins: [
                'advlist autolink link lists charmap nonbreaking table paste textcolor'
            ],
            menubar: false,
            autoresize_top_margin: 5,
            autoresize_bottom_margin: 5,
            height: 200,
            toolbar: 'undo redo | styleselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link table | forecolor backcolor',
        };

        // инициализация
        init();

        // region Function

        function init() {
            $scope.edit = false;
            $scope.support = angular.copy(support);
            $scope.support.filename = '';
        }

        function ok(reason, support) {
            $modalInstance.close({ reason, support });
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function isSelect() {
            return $scope.support != null && $scope.support.id != null;
        }

        function allowEdit() {
            $scope.edit = true;
        }

        function cancelEdit() {
            $scope.edit = false;
            $scope.support = angular.copy(support);
        }

        /**
         * Отображать кнопку редактировать?
         * @returns {boolean|*}
         */
         function isShowEdit() {
            return $security.isAllowWrite('/support-measures');
        }

        function parseArrayNames(arr) {
            return arr.length ? arr.map(n => n.name).join(', ') : 'Нет данных';
        }

        function parseArrayCodes(arr) {
            return arr.length ? arr.map(n => n.code).join(', ') : 'Нет данных';
        }

        const toBase64 = file => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });

        function parseFieldWithOperator(value1, value2, operator) {
            if (value1 === null && value2 === null) return 'Нет данных';
            if (value1 !== null) {
                if (value2 !== null) {
                    return `${value1} - ${value2}`;
                }
                return `${OperatorService.getDisplayName(operator)} ${value1}`;
            }
            return `${OperatorService.getDisplayName(operator)} ${value2}`;
         }

        async function uploadFile(file) {
            if (file && file.type === 'application/pdf') {
                $scope.support.filename = file.name;
                $scope.support.attachment = await toBase64(file);
             } else {
                 $scope.support.attachment = null;
                 $scope.support.filename = '';
             }
        }

        async function downloadFile(file) {
            if (file) {
                const link = document.createElement("a");
                link.setAttribute('download', $scope.support.name + '.pdf');
                link.href = file;
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        }

        function validate(scope) {
            $scope.formState.isValid = Boolean(scope.support.name && scope.support.supportType && scope.support.okved.length && scope.support.industry.length);
        }

        $scope.$watchGroup(['support.name', 'support.okved', 'support.supportType'], function(_n, _o, scope) {
            validate(scope);
        }, true);

        $scope.$watchCollection('support.industry', function(_n, _o, scope) {
            validate(scope);
        });

        // endregion

    }]